module.exports = __webpack_public_path__ + "static/omnichannel-7a5b1f979bba1705d115ba9ea6c5f4f7.png";